export default __webpack_public_path__ + "static/media/es-cn.875428ff.svg";